import React, { useMemo, useState } from 'react';
import {
  useGetProofersProjectsQuery,
  useGetVoicesQuery,
} from 'redux/api/app.api';
import { getProoferProjectsTableColumnsConfig } from './ProjectsTableConfig';
import useSorting from 'modules/common/hooks/useSorting';
import Table from 'modules/common/components/Table/Table';
import ProoferPendingProjects from './project-request/Proofer/ProoferPendingProjects';
import { SORT } from 'modules/common/types';
import { ColumnFiltersState } from '@tanstack/react-table';
import { getFiltersToSend } from '../common/lib';

const ProjectsTabAdmin = () => {
  const [page, setPage] = useState(1);
  const { sortBy, sortType, changeSortBy } = useSorting(
    SORT.ASC,
    'lastUpdated'
  );
  const [filters, setColumnFilters] = useState<ColumnFiltersState>([]);

  const filtersToSend = React.useMemo(
    () => getFiltersToSend(filters),
    [filters]
  );
  const [viewAllProjects, setViewAllProjects] = useState(false);

  const { data, isFetching } = useGetProofersProjectsQuery({
    index: page * 10,
    sortBy,
    sortType,
    ...filtersToSend,
  });
  const { data: voicesData } = useGetVoicesQuery();
  const columns = useMemo(() => {
    return getProoferProjectsTableColumnsConfig({
      sortBy,
      sortType,
      changeSortBy,
      voicesWithPreprocessing: voicesData?.voicesWithPreprocessing,
    });
  }, [sortBy, sortType, changeSortBy, voicesData?.voicesWithPreprocessing]);
  return (
    <>
      <ProoferPendingProjects
        viewAllRequestedProjects={viewAllProjects}
        setViewAllRequestedProjects={setViewAllProjects}
      />
      {!viewAllProjects && (
        <Table
          data={data && data.data ? data.data : []}
          columns={columns}
          isLoading={isFetching}
          getPaginationRowModel={undefined}
          totalDataCount={data ? data.totalCount : 0}
          page={setPage}
          onColumnFiltersChange={setColumnFilters}
          paginated
        />
      )}
    </>
  );
};

export default ProjectsTabAdmin;
